<template>
  <div class="code-container">
    <span class="header"
      >{{ title }}
      <button class="copy-button" @click="copyCode">
        {{ copiedName }}
      </button></span
    >

    <!-- Code Block -->
    <highlight-code :lang="language" :code="generatedCode"> </highlight-code>
  </div>
</template>

<script>
import marked from "marked";
import { trimString, replaceAll } from "../utils/helpers";

export default {
  name: "CodeContainer",
  data() {
    return {
      copied: false,
    };
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    code: {
      type: String,
      required: true,
    },
    language: {
      type: String,
      required: true,
    },
  },
  computed: {
    generatedCode() {
      return this.language === "xml"
        ? marked(replaceAll(this.code, "\t"))
        : this.code;
    },
    title() {
      return this.name.toUpperCase();
    },
    copiedName() {
      return this.copied ? "Copied" : "Copy";
    },
  },
  methods: {
    copyCode() {
      if (this.copied) return;

      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 1500);
      let newGeneratedCode = replaceAll(this.generatedCode, "\t");
      navigator.clipboard.writeText(trimString(newGeneratedCode));
    },
  },
};
</script>

<style lang="scss" scoped>
.code-container {
  overflow-wrap: break-word;
  background: #343233;
  border: solid 1px #343233;
  overflow: auto;
  margin-bottom: 8px;
  max-width: 350px;
  position: relative;
  padding-top: 30px;
  height: max-content;
  max-height: 800px;
}

.header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: block;
  color: white;
  font-weight: 300;
  font-size: 12px;
  padding: 8px;
  user-select: none;
  font-family: "Rubik";
}
.copy-button {
  top: 6px;
  right: 5px;
  position: absolute;
  color: #eee;
  background-color: Transparent;
  background-repeat: no-repeat;
  font-weight: 300;
  font-family: "Rubik";
  font-size: 13px;
  border: none;
  cursor: pointer;
  overflow: hidden;
  outline: none;
  opacity: 0.6;
  transition: opacity 0.2s ease;
  &:hover {
    opacity: 1;
  }
}

.generated-code {
  color: white;
  font-size: 13px;
  text-shadow: none;
  font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
  direction: ltr;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  line-height: 1.5;
  -moz-tab-size: 4;
  -o-tab-size: 4;
  tab-size: 4;
  -webkit-hyphens: none;
  -moz-hyphens: none;
  -ms-hyphens: none;
  hyphens: none;
  margin: 0;
  overflow-wrap: break-word;
}
</style>
